import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./style.css";
import { DatePicker } from "antd";
import locale_es from "antd/es/date-picker/locale/es_ES";

const VaporDatePicker = props => {
  const {
    className,
    style,
    defaultValue,
    disabled,
    disabledDate,
    dropdownClassName,
    format,
    onBlur,
    onChange,
    value,
    allowClear,
    placeholder,
    picker,
    placement,
    suffixIconStyle,
    locale
  } = props;

  /**
   * (GIO): ho aggiunto {...props} per poter passare props che non erano nel componente
   * es.getPopupContainer altrimenti si rompeva la data su tutte le modali.
   */
  return (
    <DatePicker
      {...props}
      className={`vapor-data-picker ${className}`}
      style={style}
      disabled={disabled}
      dropdownClassName={dropdownClassName}
      value={value}
      format={format}
      onBlur={onBlur}
      locale={locale === "es" ? locale_es : null}
      disabledDate={disabledDate}
      onChange={onChange}
      defaultValue={defaultValue}
      allowClear={allowClear}
      picker={picker}
      placeholder={placeholder}
      placement={placement}
      suffixIcon={
        <FontAwesomeIcon
          icon={["far", "calendar"]}
          style={{
            ...suffixIconStyle,
            fontSize: 14,
            color: "#152935"
          }}
        />
      }
      // getPopupContainer={(trigger) => trigger.parentNode}
    />
  );
};

VaporDatePicker.propTypes = {
  allowClear: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  defaultValue: PropTypes.any,
  disabled: PropTypes.bool,
  disabledDate: PropTypes.func,
  dropdownClassName: PropTypes.string,
  format: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  picker: PropTypes.string,
  placeholder: PropTypes.string,
  placement: PropTypes.oneOf(["topLeft", "topRight", "bottomLeft", "bottomRight"]),
  value: PropTypes.any,
  suffixIconStyle: PropTypes.object
};

VaporDatePicker.defaultProps = {
  allowClear: true,
  className: "",
  style: {},
  defaultValue: undefined,
  disabled: false,
  disabledDate: undefined,
  dropdownClassName: "",
  format: "DD-MM-YYYY",
  onBlur: undefined,
  onChange: undefined,
  picker: undefined,
  placeholder: undefined,
  placement: "bottomLeft",
  value: undefined,
  suffixIconStyle: {}
};

export default VaporDatePicker;
